import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Image,
  Divider,
  useColorModeValue,
  Link,
  Center,
  Flex,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const About = () => {
  const { t } = useTranslation();
  const bgColor = useColorModeValue("white", "gray.700");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const linkColor = useColorModeValue("blue.500", "blue.300");
  const textColor = useColorModeValue("gray.500", "gray.400");

  return (
    <Container maxW="container.md" py={8}>
      <VStack spacing={8} align="stretch">
        <Center flexDirection="column">
          <Image src="/logo.svg" alt="QazBilim Logo" boxSize="80px" mb={4} />
          <Heading as="h1" size="xl" mb={2}>
            QazBilim
          </Heading>
        </Center>
        <Divider />

        <VStack spacing={4} align="stretch" pt={2}>
          <Heading as="h2" size="lg">
            {t("about.ourMission")}
          </Heading>
          <Text>{t("about.missionDescription")}</Text>
        </VStack>

        <VStack spacing={4} align="stretch" pt={4}>
          <Heading as="h2" size="lg">
            {t("about.whatWeDo")}
          </Heading>
          <Text>{t("about.whatWeDoDescription")}</Text>
        </VStack>

        <VStack spacing={4} align="stretch" pt={4}>
          <Heading as="h2" size="lg">
            {t("about.contactUs")}
          </Heading>
          <Text color={textColor}>
            {t(
              "about.helpMessage",
              "If you want to help with our mission, please reach out to me on LinkedIn."
            )}
          </Text>
          <Link
            href="https://www.linkedin.com/in/almasmyrzatay/"
            isExternal
            color={linkColor}
            display="flex"
            alignItems="center"
          >
            <Flex alignItems="center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
                style={{ marginRight: "8px" }}
              >
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
              </svg>
              Almas Myrzatay
            </Flex>
          </Link>
        </VStack>
      </VStack>
    </Container>
  );
};

export default About;
